import styled from 'styled-components';

export const SC_TextArea = styled.textarea`
    margin-bottom: 20px;
    font-size: 16px;
`